// File-related constants
export const MAX_FILES = 10;
export const MAX_FILE_SIZE = 100 * 1024 * 1024; // 100MB
export const REQUEST_EXPIRY = 60000; // 60 seconds

// Based on OpenAI's official file search supported formats documentation
// https://platform.openai.com/docs/assistants/tools/file-search/supported-files
export const ACCEPTED_FILE_TYPES = {
  // Images
  "image/*": ["png", "jpg", "jpeg", "gif", "bmp", "webp"],

  // Documents
  "application/pdf": ["pdf"],
  "application/msword": ["doc"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    "docx",
  ],
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": [
    "pptx",
  ],

  // Text files
  "text/plain": ["txt"],
  "text/markdown": ["md"],
  "text/html": ["html"],
  "text/css": ["css"],
  "text/csv": ["csv"],

  // Programming languages
  "text/javascript": ["js"],
  "application/typescript": ["ts"],
  "application/json": ["json"],
  "text/x-python": ["py"],
  "text/x-java": ["java"],
  "text/x-c": ["c"],
  "text/x-c++": ["cpp"],
  "text/x-csharp": ["cs"],
  "text/x-golang": ["go"],
  "text/x-php": ["php"],
  "text/x-ruby": ["rb"],
  "application/x-sh": ["sh"],
  "text/x-tex": ["tex"],
};

export const VECTOR_STORE_SUPPORTED_EXTENSIONS = [
  ".c",
  ".cpp",
  ".cs",
  ".css",
  ".csv",
  ".doc",
  ".docx",
  ".go",
  ".html",
  ".java",
  ".js",
  ".json",
  ".md",
  ".pdf",
  ".php",
  ".pptx",
  ".py",
  ".rb",
  ".sh",
  ".tex",
  ".ts",
  ".txt",
];

export const MIME_TO_EXTENSION = {
  "text/plain": ".txt",
  "text/markdown": ".md",
  "application/json": ".json",
  "text/html": ".html",
  "text/css": ".css",
  "text/csv": ".csv",
  "application/javascript": ".js",
  "text/javascript": ".js",
  "application/typescript": ".ts",
  "application/pdf": ".pdf",
  "application/msword": ".doc",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    ".docx",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation":
    ".pptx",
  "text/x-python": ".py",
  "application/x-python-code": ".py",
  "text/x-java-source": ".java",
  "text/x-java": ".java",
  "text/x-c": ".c",
  "text/x-c++": ".cpp",
  "text/x-csharp": ".cs",
  "text/x-golang": ".go",
  "application/x-php": ".php",
  "text/x-php": ".php",
  "text/x-ruby": ".rb",
  "application/x-sh": ".sh",
  "application/x-tex": ".tex",
  "text/x-tex": ".tex",
  // Google Workspace MIME types (these get exported to supported formats)
  "application/vnd.google-apps.document": ".docx",
  // Note: Google Sheets export as CSV instead of xlsx
  "application/vnd.google-apps.spreadsheet": ".csv",
  "application/vnd.google-apps.presentation": ".pptx",
  "application/vnd.google-apps.script": ".js",
};
